<template>
<div style="background-color:#F5F9FC">

  <div class="container" >
    <div class="outer-container">
      <h2>
        How will it work?
      </h2>
      <br />
      <h4>
   If you are selected, then you will be required to deposit Tk. 3,000, which will be refunded once you complete the program.
    This is to ensure that you do not drop out in the middle of the course.
    <br> <br>
     If you are hired, you will be required to pay us a total of Tk. 50,000 in 5 equal installments <br>
      (Tk. 10,000/monthly) after you are confirmed as a full-time employee.
      </h4>
      <div class="grid">
        <div class="white-bg">
          <h3>
            GET REAL WORK <br />
            EXPERIENCE
          </h3>
          <p>
            Master the skills most required for machine learning engineers by
            completing this 1.5 months practical and project-based course.
          </p>
        </div>

        <div class="white-bg">
          <h3>
           NO FEES UNLESS <br />
            YOU'RE HIRED
          </h3>
          <p>
           You’ll only pay the fees to Upskill if you are hired by Intelligent Machines. You’ll make a five-installment payment of  BDT 10,000/monthly.
          </p>
        </div>
        <div class="white-bg">
          <h3>
            GET CONNECTED <br /> <br>

          </h3>
          <p>
          Successfully complete the machine learning course and assessments to be interviewed by Intelligent Machines.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {};
</script>

<style scoped>
.outer-container {
  padding: 0 25px;
  padding-top: 100px;
  padding-bottom: 90px;
}
.outer-container h2 {

  font-family: "Open Sans";
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 7.2px;
  line-height: 24px;
  color: #035BF4;
  padding-bottom: 35px;
  border-bottom:  2px solid #C8C9CC;;
}
.outer-container h4 {
   font-family: "Open Sans";
  font-size: 24px;
  font-weight: 700;

  line-height: 32px;
  letter-spacing: -0.6px;
color: #3C4663;

  padding-bottom: 50px;
}
.grid {
  display: grid;
grid-template-columns: repeat( auto-fit, minmax(390px, 1fr) );
grid-gap: 49px;

}
.grid h3 {
  padding-top: 40px;
  padding-left: 40px;
  font-family: "Open Sans";
  text-transform: uppercase;
  font-size: 24px;
  font-weight: 800;

  line-height: 24px;
letter-spacing: 0px;
color: #FF165D;
  padding-bottom: 48px;
}
.grid p {
    padding-left: 40px;
font-family: "Open Sans";
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #84888B;
  padding-right: 25px;
}
.white-bg{
  background-color: white;
  box-shadow: 0px 10px 30px #3C46630D;
border-radius: 10px;
min-height: 300px;
}
@media only screen and (min-width: 601px) and (max-width: 1100px) {
  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 600px) {
  .container {
    padding-left: 0;
    padding-right: 0;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
  .outer-container {
    padding: 0 20px;
    padding-top: 50px;
    padding-bottom: 45px;
  }
  .outer-container h2 {
    font-size: 16px;
    letter-spacing: 6.4px;
    line-height: 24px;
    padding-bottom: 30px;
  }
  .outer-container h4 {
    font-family: "Poppins";
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 24px;
    color: #304f64;
    padding-top: 0px;
    padding-bottom: 10px;
  }
  .grid h3 {
    padding-bottom: 20px;
    padding-top: 30px;
    padding-right: 0;
  }
}
@media only screen and (min-width: 1300px) {
  .container {
    max-width: 1350px !important;
  }
}
</style>
